import React, { useMemo, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Modal from '../Gallery/Modal';
import servicePosts from '../data/data-service.json';
import { companyInfo } from '../data/companyInfo';

const sidebarCategories = [
    { title: 'Tour Planning Services', count: 8 },
    { title: 'Transport & Logistics', count: 6 },
    { title: 'Guided Experiences', count: 7 },
    { title: 'Honeymoon & Family Support', count: 5 },
    { title: 'Corporate Group Management', count: 4 },
    { title: 'Photography Add-ons', count: 3 }
];

const fallbackGallery = [
    '/assets/img/gallery/gallery_6_1.jpg',
    '/assets/img/gallery/gallery_6_2.jpg',
    '/assets/img/gallery/gallery_6_3.jpg',
    '/assets/img/gallery/gallery_6_4.jpg'
];

function ServiceDetailsMain() {
    const { slug } = useParams();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState('');

    const servicePost = useMemo(() => {
        if (!slug) {
            return servicePosts[0];
        }

        const bySlug = servicePosts.find((post) => post.slug === slug);
        if (bySlug) {
            return bySlug;
        }

        const parsedId = parseInt(slug, 10);
        if (!Number.isNaN(parsedId)) {
            return servicePosts.find((post) => post.id === parsedId) || servicePosts[0];
        }

        return servicePosts[0];
    }, [slug]);

    const gallery = servicePost.gallery?.length ? servicePost.gallery : fallbackGallery;
    const recentPosts = servicePost.recentPosts || [];
    const tags = servicePost.tags || [];

    const openModal = (imageSrc, event) => {
        event.preventDefault();
        setModalImage(imageSrc);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <section className="space">
            <div className="container shape-mockup-wrap">
                <div className="row">
                    <div className="col-xxl-8 col-lg-7">
                        <div className="page-single">
                            <div className="service-img">
                                <img src={`/assets/img/destination/${servicePost.bannerImg}`} alt={servicePost.title} />
                            </div>

                            <div className="page-content d-block">
                                <div className="page-meta mt-50 mb-45">
                                    <Link className="page-tag" to="/service">
                                        {servicePost.featuredTag || 'Service'}
                                    </Link>
                                    <span className="ratting">
                                        <i className="fa-sharp fa-solid fa-star" />
                                        <span>4.8</span>
                                    </span>
                                </div>

                                <h2 className="box-title">{servicePost.title}</h2>
                                <p className="box-text mb-30">{servicePost.overviewOne}</p>
                                <p className="box-text mb-40">{servicePost.overviewTwo}</p>

                                {servicePost.innerImage && (
                                    <div className="service-inner-img mb-40">
                                        <img
                                            src={`/assets/img/destination/${servicePost.innerImage}`}
                                            alt={servicePost.title}
                                        />
                                    </div>
                                )}

                                <h2 className="box-title">Highlights</h2>
                                <div className="checklist mb-40">
                                    <ul>
                                        {servicePost.highlights?.map((item, index) => (
                                            <li key={index}>{item}</li>
                                        ))}
                                    </ul>
                                </div>

                                <div className="destination-checklist mb-20">
                                    <div className="checklist style2">
                                        <ul>
                                            <li>Availability</li>
                                            <li>Best For</li>
                                            <li>Pricing</li>
                                        </ul>
                                    </div>
                                    <div className="checklist style2">
                                        <ul>
                                            <li>{servicePost.availability}</li>
                                            <li>{servicePost.bestFor}</li>
                                            <li>{servicePost.pricingNote}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="destination-gallery-wrapper">
                                <h3 className="page-title mt-30 mb-30">From our gallery</h3>
                                <div className="row gy-4 gallery-row filter-active">
                                    {gallery.map((imageSrc, index) => (
                                        <div className="col-xxl-auto filter-item" key={index}>
                                            <div className="gallery-box style3">
                                                <div className="gallery-img global-img">
                                                    <img src={imageSrc} alt={`${servicePost.title} ${index + 1}`} />
                                                    <Link
                                                        to={imageSrc}
                                                        className="icon-btn popup-image"
                                                        onClick={(event) => openModal(imageSrc, event)}
                                                    >
                                                        <i className="fal fa-magnifying-glass-plus" />
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xxl-4 col-lg-5">
                        <aside className="sidebar-area style3">
                            <div className="widget widget_search">
                                <form className="search-form">
                                    <input type="text" placeholder="Search" />
                                    <button type="submit">
                                        <i className="far fa-search" />
                                    </button>
                                </form>
                            </div>

                            <div className="widget widget_categories">
                                <h3 className="widget_title">Categories</h3>
                                <ul>
                                    {sidebarCategories.map((category) => (
                                        <li key={category.title}>
                                            <Link to="/service">
                                                <img src="/assets/img/theme-img/map.svg" alt="" />
                                                {category.title}
                                            </Link>
                                            <span>({category.count})</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="widget tour-booking">
                                <p className="widget_subtitle">
                                    From <span className="widget_price">{servicePost.pricingNote}</span>
                                </p>
                                <div className="info-list">
                                    <ul>
                                        <li>
                                            <strong>Availability</strong>
                                            <span>{servicePost.availability}</span>
                                        </li>
                                        <li>
                                            <strong>Best for</strong>
                                            <span>{servicePost.bestFor}</span>
                                        </li>
                                    </ul>
                                </div>
                                <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn th-icon">
                                    Book Now
                                </Link>
                                <span className="review">
                                    <i className="fa-light fa-heart" /> Personalized support available for this service
                                </span>
                            </div>

                            <div className="widget">
                                <h3 className="widget_title">Recent Posts</h3>
                                <div className="recent-post-wrap">
                                    {recentPosts.map((post, index) => (
                                        <div className="recent-post" key={index}>
                                            <div className="media-img">
                                                <Link to="/blog/1">
                                                    <img src={post.image} alt="Blog" />
                                                </Link>
                                            </div>
                                            <div className="media-body">
                                                <h4 className="post-title">
                                                    <Link className="text-inherit" to="/blog/1">
                                                        {post.title}
                                                    </Link>
                                                </h4>
                                                <div className="recent-post-meta">
                                                    <Link to="/blog">
                                                        <i className="fa-regular fa-calendar" />
                                                        {post.date}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="widget widget_tag_cloud">
                                <h3 className="widget_title">Popular Tags</h3>
                                <div className="tagcloud">
                                    {tags.map((tag) => (
                                        <Link key={tag} to="/service">
                                            {tag}
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            <div className="widget widget_offer" style={{ background: 'url(/assets/img/bg/widget_bg_1.jpg)' }}>
                                <div className="offer-banner">
                                    <div className="offer">
                                        <h6 className="box-title">Need Help? We Are Here To Help You</h6>
                                        <div className="banner-logo">
                                            <img src="/assets/img/primary-logo.png" alt="Himolan Peak Adventures" />
                                        </div>
                                        <div className="offer">
                                            <h6 className="offer-title">You Get Online support</h6>
                                            <Link className="offter-num" to={`tel:${companyInfo.phoneDial}`}>
                                                {companyInfo.phoneDisplay}
                                            </Link>
                                        </div>
                                        <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style2 th-icon">
                                            Read More
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>

                <div className="shape-mockup shape1 d-none d-xxl-block" style={{ bottom: '35%', right: '-12%' }}>
                    <img src="/assets/img/shape/shape_1.png" alt="shape" />
                </div>
                <div className="shape-mockup shape2 d-none d-xl-block" style={{ bottom: '31%', right: '-8%' }}>
                    <img src="/assets/img/shape/shape_2.png" alt="shape" />
                </div>
                <div className="shape-mockup shape3 d-none d-xxl-block" style={{ bottom: '33%', right: '-5%' }}>
                    <img src="/assets/img/shape/shape_3.png" alt="shape" />
                </div>
            </div>

            <Modal isOpen={isModalOpen} closeModal={closeModal} imageSrc={modalImage} />
        </section>
    );
}

export default ServiceDetailsMain;


